export default {
  title: 'Detalhes fiscais',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Informação guardada com sucesso.',
  },
};
